































































































































































































































































































import { Component, Prop, Vue, Watch } from "@/shared/vuepack";
import { FundingOption } from "@/shared/types";
import { CensusManager, CompanyDetails, PartnerEmployer } from "@/employer/types";
import UsStateSelector from "@/shared/components/UsStateSelector.vue";
import Input from "@/shared/components/ui/Input.vue";
import Checkbox from "@/shared/components/ui/Checkbox.vue";
import Button from "@/shared/components/ui/Button.vue";
import ErrorSummary from "@/shared/components/ErrorSummary.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { Validator } from "vee-validate";
import * as _ from "lodash";
import moment from "moment";
import CompanyHelper from "../settings/CompanyHelper";
import EmployerPhone from "@/employer/components/shared/EmployerPhone.vue";
import UmbOnboardingInfo from "@/employer/components/resources/UmbOnboardingInfo.vue";
import AvidiaOnboardingInfo from "@/employer/components/resources/AvidiaOnboardingInfo.vue";
import AllegacyOnboardingInfo from "@/employer/components/resources/AllegacyOnboardingInfo.vue";
import { usePartnerStore } from "@/employer/store/partner";
import { useProfileStore } from "@/employer/store/profile";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useUserStore } from "@/shared/store/user";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";

  @Component ({
    components: {
      UsStateSelector,
      Input,
      Checkbox,
      Button,
      EmployerPhone,
      ErrorSummary,
      GenericLoadingSpinner,
      AvidiaOnboardingInfo,
      UmbOnboardingInfo,
      AllegacyOnboardingInfo
    }
  })
  export default class GeneralInformation extends Vue {
    $validator: Validator;

    partnerStore = usePartnerStore();
    profileStore = useProfileStore();
    userStore = useUserStore();
    custodianSettingsStore = useCustodianSettingsStore();
    featureFlagStore = useFeatureFlagStore();

    isFundingBaDirty = true;
    isSubmitting = false;
    resetAgreeOnEdit = false;

    formModel: CompanyDetails = null;
    fundingBankAccountConfirm = "";

    companyHelper: CompanyHelper;

    get employerId () { return this.forEmployerId || this.userStore.employerId; }

    @Prop({required: false})
    forEmployerId: number;

    @Prop({required: false})
    isSelfSignup: boolean;

    @Prop({default: true})
    allowCustodianEdit: () => boolean;

    @Prop()
    partnerId: number;

    initializeFromStateValue () {
      if (!this.profileStore.isLoaded) {
        return;
      }

      this.formModel = _.cloneDeep({ profileInformation: this.profileStore.employerInformation,
        bankInformation: this.profileStore.bankInformation,
        fundingOption: this.profileStore.fundingOption,
        enrollmentOption: this.profileStore.enrollmentOption });

      this.formModel.profileInformation.employerId = this.employerId;
      this.fundingBankAccountConfirm = this.formModel.bankInformation.fundingAccount.bankAccountNumber;

      this.setDirtyState();
      this.companyHelper = new CompanyHelper(this.profileStore.bankInformation);
    }

    @Watch("profileStore.employerInformationState")
    onLoadingStateChange () {
      this.initializeFromStateValue();
    }

    created () {
      this.partnerStore.loadEmployerByEmployerId({ partnerId: this.partnerId, employerId: this.employerId });
      this.initializeFromStateValue();
      this.profileStore.loadProfileInformation(this.employerId);
      this.profileStore.loadFundingOption(this.employerId);
      this.profileStore.loadFundingOptionHistory(this.employerId);
      this.profileStore.loadEnrollmentOption(this.employerId);
      this.loadEmployerCustodian();
    }

    @Watch("profileStore.fundingOption")
    fundingOptionChange () {
      this.formModel.fundingOption = this.profileStore.fundingOption;
      if (this.partnerId) {
        if (this.partnerEmployer) {
          this.partnerEmployer.fundingOption = this.profileStore.fundingOption;
        }
      }
    }

    @Watch("profileStore.enrollmentOption")
    enrollmentOptionChange () {
      this.formModel.enrollmentOption = this.profileStore.enrollmentOption;
      if (this.partnerId) {
        if (this.partnerEmployer) {
          this.partnerEmployer.enrollmentOption = this.profileStore.enrollmentOption;
        }
      }
    }

    get partnerEmployer (): PartnerEmployer {
      const employer = this.partnerStore.selectedEmployerByEmployerId(this.employerId);
      if (employer) {
        return employer;
      }
      return null;
    }

    get isEnrollmentDisabled (): boolean {
       if (!this.partnerEmployer) return false;

      return this.partnerEmployer.censusManager === CensusManager.employeeNavigator;
    }

    @Watch("profileStore.isLoaded")
    loadEmployerCustodian () {
      if (this.employerId && this.profileStore.isLoaded) {
        this.custodianSettingsStore.getEmployerCustodian(this.employerId);
      }
    }

    get showAutomatedFundingOption () {
      return this.profileStore.fundingOption === FundingOption.BendCalculatePull
        || !this.profileStore.fundingOptionHistory.includes(FundingOption.BendCalculatePull);
    }

    get submitDisabled () {
      return this.$validator.errors.any() || this.isSubmitting;
    }

    get shouldShowDebitAgreementField () {
      if (!this.showBankInformation) {
        return false;
      }

      return this.resetAgreeOnEdit ? this.resetAgreeOnEdit : !!this.companyHelper.bankAccountFeeConfirmFieldIsRequired;
    }

    get debitAgreementValue () {
      return (this.formModel !== null && !!this.formModel.bankInformation.authorizationDate);
    }

    set debitAgreementValue (didAgree: boolean) {
      if (didAgree) {
        this.formModel.bankInformation.authorizationDate = moment.utc().format();
      } else {
        this.formModel.bankInformation.authorizationDate = "";
      }
    }

    get confirmFundingBankAccountValidator () {
      return this.formModel.bankInformation.fundingAccount.bankAccountNumber ?
      "required|confirmed:bank-account-hsa" : "required";
    }

    get showFundingMethod () {
      return this.featureFlagStore.flags.showFundingMethod;
    }

    get showEnrollmentOptions () {
      return this.featureFlagStore.flags.showBulkEnrollment && this.custodianSettingsStore.displayAvidiaOptions;
    }

    get showBankInformation () {
      return !this.showFundingMethod
          || (this.showFundingMethod && (this.formModel.fundingOption === FundingOption.BendCalculatePull
              || this.formModel.fundingOption === FundingOption.ErCalculateBendPull));
    }

    get displayOnboardingBankInformation () {
      return this.showBankInformation && this.custodianSettingsStore.displayEmployerOnboardingBankInformation;
    }

    onClickEditFundingBa () {
      this.isFundingBaDirty = true;
      this.formModel.bankInformation.authorizationDate = null;
      this.resetAgreeOnEdit = true;
    }

    onSubmit (formModel: CompanyDetails): void {
      this.$validator.validateAll()
      .then(isValid => {
        if (!isValid) {
          return;
        }
        this.isSubmitting = true;

        // we do not differentiate funding and fee accounts
        // save them as the same value without user input
        this.formModel.bankInformation.feeAccount = this.formModel.bankInformation.fundingAccount;
        this.profileStore.saveProfileInformation({ profileInformation: formModel.profileInformation,
                                      bankInformation: formModel.bankInformation,
                                      fundingOption: formModel.fundingOption,
                                      enrollmentOption: formModel.enrollmentOption})
            .then(() => this.partnerStore.resetPartnerFetchState())
            .then(this.setDirtyState)
            .then(resp => this.$emit("complete"))
            .then(() => { this.isSubmitting = false; })
            .catch(() => { this.isSubmitting = false; });
            });
    }
    get isBankCustodianVisible (): boolean {
      return this.allowCustodianEdit &&
        this.formModel.profileInformation.allowedEmployerBankCustodians.length > 1;
    }
    setDirtyState () {
      const fundingBa = this.formModel.bankInformation.fundingAccount;
      this.isFundingBaDirty = !fundingBa.bankAccountNumber;
    }
  }
